import { Alert, AlertColor, AlertProps, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { OptionsObject, SnackbarKey, VariantType } from "notistack";

interface CustomSnackAlarmProps extends AlertProps {
  key?: SnackbarKey;
  closeSnackbar?: Function;
  customActionLabel?: string;
  customAction?: Function;
}

const alertOptions = (props?: CustomSnackAlarmProps): AlertProps => {
  const { key, elevation, closeSnackbar, severity, customAction, customActionLabel } = props || {};
  if (props) {
    delete props.closeSnackbar;
    delete props.customAction;
    delete props.customActionLabel;
  }

  let action = undefined,
    actionButton,
    closeAction;
  if (closeSnackbar) {
    closeAction = (
      <IconButton
        aria-label="close"
        color="inherit"
        size="small"
        onClick={() => {
          closeSnackbar(key);
        }}
      >
        <CloseIcon fontSize="inherit" />
      </IconButton>
    );
  }
  if (customAction) {
    actionButton = (
      <Button size="small" color="inherit" sx={{ textTransform: "uppercase" }} onClick={() => customAction(key)}>
        {customActionLabel}
      </Button>
    );
  }
  if (closeSnackbar && customAction) {
    action = (
      <>
        {actionButton}
        {closeAction}
      </>
    );
  } else if (closeSnackbar) {
    action = closeAction;
  } else if (customAction) {
    action = actionButton;
  }

  return {
    elevation: elevation || 2,
    action,
    icon: !severity ? false : undefined,
    sx: !severity
      ? {
          backgroundColor: "text.primary",
          color: "background.paper",
        }
      : undefined,
    ...props,
  };
};

const snackVariantToAlertSeverity = (variant?: VariantType): AlertColor | undefined => {
  switch (variant) {
    case "error":
    case "warning":
    case "info":
    case "success":
      return variant;
    default:
      return undefined;
  }
};

export const snackbarOptions = (props?: OptionsObject, alarmProps?: CustomSnackAlarmProps): OptionsObject => {
  return {
    content: (key, message) => <Alert {...alertOptions({ key, severity: snackVariantToAlertSeverity(props?.variant), ...alarmProps })}>{message}</Alert>,
    ...props,
  };
};
